module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "pink darken-2",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Tableau des Activités Principales des Sénateurs")]), _vm._v(" "), _c('v-spacer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d19f886","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccueilToolbar.vue
// module id = 376
// module chunks = 1